import { Button } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import { ArrowUpDown } from 'lucide-react';
import { SORT_MODES } from '../workspaceSelectorData.js';

const SORT_LABEL_KEY = {
  recent: 'workspaceSelector.sort.recent',
  alpha: 'workspaceSelector.sort.alpha',
  role: 'workspaceSelector.sort.role',
};

/**
 * Sort control: a single button that cycles Last visited → A–Z → Role, matching
 * the prototype (a cycle, not a dropdown).
 *
 * The visible label is the CURRENT mode, so the accessible name has to say that
 * out loud plus what pressing it does — "Sort by A–Z" on a button that is
 * already sorting by A–Z reads like a pending action instead of current state.
 */
function SelectorSort({ mode, onCycle }) {
  const { t } = useTranslation('core-shell');

  const next = () => {
    const idx = SORT_MODES.indexOf(mode);
    onCycle(SORT_MODES[(idx + 1) % SORT_MODES.length]);
  };

  const label = t(SORT_LABEL_KEY[mode] ?? SORT_LABEL_KEY.recent);

  return (
    <Button
      variant="secondary"
      size="sm"
      leftIcon={ArrowUpDown}
      onClick={next}
      aria-label={t('workspaceSelector.sortedBy', { mode: label })}
    >
      {label}
    </Button>
  );
}

export default SelectorSort;
